import React, { useEffect, useState } from 'react';
import { Button, Form, Modal, Spin } from 'antd';
import { observer } from 'mobx-react';
import FormComponent from './FormComponent';
import useStore from '../../../../store';
import { Notification } from '../../../../config/Global';
import Message from '../../../../config/Message';

const EditComponent = observer((props) => {
	const { visible, onClose } = props;
	const [form] = Form.useForm();
	const {
		REGION,
		TEMPLE,
		TEMPLE: { templeImageDetails },
		AUTH,
	} = useStore();
	const { regionDetail } = REGION;
	const [disabled, setDisabled] = useState(true);
	const [saving, setSaving] = useState(false);
	const [fileLists, setFileLists] = useState();

	const handleSubmit = async (data) => {
		setSaving(true);
		try {
			const response = await REGION.editRegion({
				...data,
				id: regionDetail.id,
				regionType: data.regionType === "State" ? 2 : data.regionType,
				versionNo: regionDetail.versionNo,
			});
			if (fileLists) {
				if (templeImageDetails && templeImageDetails.length) {
					if (templeImageDetails[0].id !== fileLists[0].uid) {
						await AUTH.onRemoveImage(
							templeImageDetails[0].id,
							templeImageDetails[0].versionNo,
							true
						);
					}
				}
				const formData = new FormData();
				formData.append('RefTablename', 'region');
				formData.append('ERefRecordid', regionDetail.id);
				formData.append('Imagefile', fileLists[0]);
				formData.append('Description', data.regionName);
				formData.append('ImageType', 4);
				formData.append('isApproved', true);
				await AUTH.ImageUpload(formData);
			}
			if (response.httpStatusCode === 200) {
				Notification.success({
					message: Message().CRUD.UPDATE('Region'),
				});
			} else {
				Notification.error({
					message: imageUploadResponse,
				});
			}

			closeModal();
		} catch (error) {
			// const errorData = ROOT.assignErrorToInput(error);
			// form.setFieldsValue({ error: errorData });
		} finally {
			setSaving(false);
		}
	};

	const handleChange = () => {
		setTimeout(() => {
			form.validateFields({ validateOnly: true })
				.then(() => {
					setDisabled(false);
				})
				.catch(() => {
					setDisabled(true);
				});
		}, 0);
	};

	const closeModal = () => {
		setDisabled(true);
		form.resetFields();
		REGION.regionDetail = null;
		setFileLists(null);
		onClose();
	};

	const handlesetFormData = async (id) => {
		let reqPayload = {
			tableName: 'region',
			templeID: regionDetail.id,
		};

		const data = await TEMPLE.ReadTempleImagedetail(reqPayload);
		if (data && data.length) {
			const newFileLists = [
				{
					uid: data[0].id,
					name: data[0].filename,
					url:
						data[0].bunnyLink ||
						URL.createObjectURL(data[0].bunnyLink),
					status: 'done', // e.g., done, uploading, error
				},
			];
			setFileLists(newFileLists);
		}
	};

	useEffect(() => {
		if (visible && regionDetail) {
			handlesetFormData();
			form.setFieldsValue({
				regionType:
					Number(regionDetail.regionType) === 2
						? 'State'
						: Number(regionDetail.regionType),
				EParentRegionId: regionDetail.eParentRegionId,
				regionCode: regionDetail.regionCode,
				regionName: regionDetail.regionName,
				propertyMetaTitle: regionDetail.propertyMetaTitle,
				propertyMetaDescription: regionDetail.propertyMetaDescription,
				propertyMetaKeywords: regionDetail.propertyMetaKeywords,
				templeMetaTitle: regionDetail.templeMetaTitle,
				templeMetaDescription: regionDetail.templeMetaDescription,
				templeMetaKeywords: regionDetail.templeMetaKeywords,
				templeSEOTitle: regionDetail.templeSEOTitle,
				propertySEOTitle: regionDetail.propertySEOTitle
			});
		}
	}, [visible, regionDetail]);

	return (
		<Modal
			title="Edit Region"
			onCancel={closeModal}
			open={visible}
			destroyOnClose
			width={'500px'}
			footer={
				<div>
					<Button
						type="primary"
						key={1}
						disabled={disabled}
						htmlType="submit"
						loading={saving}
						form="EditForm"
					>
						Update Region
					</Button>
					<Button key={2} onClick={closeModal}>
						Cancel
					</Button>
				</div>
			}
		>
			<Spin spinning={!regionDetail}>
				<FormComponent
					id="EditForm"
					form={form}
					onFinish={handleSubmit}
					handleChange={handleChange}
					setFileLists={setFileLists}
					fileLists={fileLists}
				/>
			</Spin>
		</Modal>
	);
});

export default EditComponent;
